<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4 5.7002H12.6C12.9313 5.7002 13.2 5.96882 13.2 6.3002V10.8002H17.7C18.0313 10.8002 18.3 11.0688 18.3 11.4002V12.6002C18.3 12.9316 18.0313 13.2002 17.7 13.2002H13.2V17.7002C13.2 18.0316 12.9313 18.3002 12.6 18.3002H11.4C11.0686 18.3002 10.8 18.0316 10.8 17.7002V13.2002H6.29995C5.96858 13.2002 5.69995 12.9316 5.69995 12.6002V11.4002C5.69995 11.0688 5.96858 10.8002 6.29995 10.8002H10.8V6.3002C10.8 5.96882 11.0686 5.7002 11.4 5.7002Z"
      fill="currentColor"
    />
  </svg>
</template>
